import React from "react";
import { useT } from "@/lib/LanguageContext";
import { Shield } from "lucide-react";

// Stands in for the practice in the translated sentence, which is then split around it so
// the name is rendered as a React text node (never markup, never re-read as a template).
const PRACTICE_SLOT = "__PRACTICE__";

/**
 * "You are managing {practice} as Solunary Super-Admin": shown to a platform operator inside
 * a practice's dashboard. `practiceName` is the practice's display name (its name, else its
 * slug); nothing is shown until it is known.
 */
export const SuperAdminBanner = ({ practiceName }) => {
  const t = useT("admin");
  if (!practiceName) return null;
  const parts = t("banner.managingAs", { practice: PRACTICE_SLOT }).split(PRACTICE_SLOT);
  return (
    <div
      data-testid="super-admin-banner"
      className="bg-amber-300 text-sol-midnight px-6 py-2.5 flex items-center justify-between text-sm border-b border-amber-400/60"
    >
      <div className="flex items-center gap-2">
        <Shield size={14} />
        <span>
          {parts.map((part, i) => (
            <React.Fragment key={`bm-${i}`}>
              {part}
              {i < parts.length - 1 && <strong>{practiceName}</strong>}
            </React.Fragment>
          ))}
        </span>
      </div>
      <a
        href="/super-admin"
        className="font-semibold hover:underline flex items-center gap-1"
        data-testid="return-to-super-admin"
      >
        {t("banner.return")}
      </a>
    </div>
  );
};
